import { useCallback, useMemo } from 'react';

import { AgendaAppointmentModalAction } from '../../../data/data/enums';
import { AppointmentModalData } from '../../../data/data/types';
import { slotTypeToConsultType } from '../../../data/data/utils';
import {
  AgendaAppointmentItemDataFragment,
  AgendaSlotItemDataFragment,
  SlotType,
} from '../../../data/types/api/graphql';
import {
  Button,
  ButtonIcon,
  ButtonType,
} from '../../../elements/button/button';
import { getAgendaSlotAppointmentInput } from '../modals/agenda-appointment-modal/agenda-appointment-modal';
import { AgendaAppointmentToggleListItem } from './agenda-appointment-toggle-list-item';

type AgendaAppointmentToggleListProps = {
  healthProviderId: string | null | undefined;
  healthProfessionalId: string | null | undefined;
  compact?: boolean;
  agendaSlotItem: AgendaSlotItemDataFragment;
  agendaAppointmentItems: AgendaAppointmentItemDataFragment[];
  showAppointmentModal?: (
    slotType: SlotType,
    value: AppointmentModalData | null
  ) => void;
};

export function AgendaAppointmentToggleList({
  healthProviderId,
  healthProfessionalId,
  compact,
  agendaSlotItem,
  agendaAppointmentItems,
  showAppointmentModal,
}: AgendaAppointmentToggleListProps) {
  const onSelect = useCallback(() => {
    // TODO BULK GET BULKID?
    showAppointmentModal?.(agendaSlotItem?.slotType, {
      action: AgendaAppointmentModalAction.CREATE,
      healthProviderId,
      agendaAppointmentItem: getAgendaSlotAppointmentInput(
        agendaSlotItem,
        healthProfessionalId,
        slotTypeToConsultType(agendaSlotItem?.slotType)
      ),
    });
  }, [
    agendaSlotItem,
    healthProfessionalId,
    healthProviderId,
    showAppointmentModal,
  ]);

  const isInPast = useMemo(() => {
    const appointmentDate = new Date(agendaSlotItem.startTime);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return appointmentDate < today;
  }, [agendaSlotItem]);

  return (
    <div className="content-list">
      {agendaAppointmentItems.map(option => (
        <div
          key={`toggle-list-item-${option.id}-${option.startTime}-${option.endTime}`}
          className={`content-list__item${compact ? '--compact' : ''}`}
        >
          <AgendaAppointmentToggleListItem
            showAppointmentModal={showAppointmentModal}
            compact={compact}
            healthProviderId={healthProviderId}
            healthProfessionalId={healthProfessionalId}
            agendaAppointmentItem={option}
          />
        </div>
      ))}
      <div className="content-list__item">
        <div
          className={`appointment-slot-list-item${compact ? ' compact' : ''}`}
        >
          <div className="appointment-slot-list-item__action">
            <Button
              type={ButtonType.TRANSPARENT}
              icon={ButtonIcon.PLUS}
              disabled={isInPast}
              onClick={() => onSelect()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
